import React, { Component } from "react";
import NewsForm from "./NewsForm/NewsForm";
import SmallModal from "../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class News extends Component {
  state = {
    project_news_id: null
  };

  componentDidMount() {
    this.props.news.fetch();
  }

  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <NewsForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentNews={
              this.props.news.news.filter(
                item => item.project_news_id === this.state.project_news_id
              )[0]
            }
            update={this.props.news.update}
            projectID={this.props.currentProjectID}
            add={this.props.news.add}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }
    return (
      <div className={"container-fluid"}>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              className="my-2"
              color="blue"
              onClick={() => {
                this.setState({ project_news_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New News
            </Button>
          </div>
        )}
        {smallModal}

        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Publisher</th>
              <th>Date Published</th>
              {this.props.disabled ? null : <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.news.news.map(item => (
              <tr
                key={item.project_news_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      project_news_id: item.project_news_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.news_title}</td>
                <td>{item.news_publisher}</td>
                <td>
                  {item.news_date.slice(0, 10)}&nbsp;
                  {item.news_date.slice(11, 16)}
                </td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          project_news_id: item.project_news_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color={"red"}
                      type="button"
                      onClick={() =>
                        this.props.news.delete(
                          item.project_news_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default News;
